module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch04"
    }
  }, [_c('a', {
    attrs: {
      "id": "page4"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterTitle"
  })])]), _c('div', {
    staticClass: "chapterBody"
  }, [_c('a', {
    attrs: {
      "id": "page4"
    }
  }, [_c('p', {
    staticClass: "chapterOpenerText"
  }, [_c('span', {
    staticClass: "chapterOpenerFirstWords"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("By the simple act of thinking,")])]), _vm._v(" vortexes are created, invisible energies are applied, and circumstances begin creeping to make real what was previously just imagined. This supernatural pull of your thoughts continues long after you think them, whenever there follows intent, expectation, and action; moving mountains, parting rivers, and doing the “impossible” until there is the inevitable manifestation.")]), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak"
  })]), _c('p', {
    staticClass: "paraCenter"
  }, [_c('a', {
    attrs: {
      "id": "page4"
    }
  }, [_vm._v("This is how your “thoughts become things.” How they physically become things in a dimension that already exists, with billions of players and massive momentum. Not by appearing out of thin air, but through a manipulation of forces in the unseen that literally begin shifting, morphing, ")]), _c('a', {
    attrs: {
      "id": "page5"
    }
  }, [_vm._v("and rearranging all of the elements in your life so as to deliver to you the nearest equivalent of what you’ve been thinking. In other words, the “law of attraction.”")])]), _c('a', {
    attrs: {
      "id": "page5"
    }
  }, [_c('p', {
    staticClass: "spaceBreak"
  }), _vm._v(" "), _c('p', {
    staticClass: "paraCenter"
  }, [_vm._v("“Thoughts become things” explains the law of attraction. It’s why there is a law of attraction. And unlike any other three words in all the vocabularies of all the languages in all the world, “thoughts become things” tells you exactly where you fit into the picture, as the thinker, the decision maker over what you will think about, revealing your power as a supernatural, all-powerful, unlimited CREATOR.")]), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak"
  }), _vm._v(" "), _c('p', {
    staticClass: "paraCenter"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("But, of course, many prefer not to think of themselves as so phenomenally powerful.")])])])]), _c('a', {
    attrs: {
      "id": "page5"
    }
  })]), _c('a', {
    attrs: {
      "id": "page5"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6c9bfae1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781416594161_ch04.vue
// module id = 99
// module chunks = 0